<div class="general-container" [ngClass]="{'!w-[327px] !p-6': bp.isCompact()}">
  <div class="heading-title">
    <span class="title-text">¿Olvidaste tu contraseña?</span>
    <span class="body-text"
      >No te preocupes, eso pasa. Escribe el correo electrónico asociado a tu
      cuenta.</span
    >
  </div>
  <form class="form-styles" [formGroup]="recoveryForm">
    <mg-input
      label="Correo electrónico"
      placeholder="ejemplo@mail.com"
      class="w-full"
      [ngClass]="{'min-w-[340px]': !bp.isCompact()}"
      [required]="true"
      [errors]="{
          required: 'Este campo no puede quedar vacío.',
          email: 'El correo electrónico es incorrecto.',
        }"
      [control]="$any(recoveryForm.get('email'))"
      [value]="recoveryForm.value.email"
      (keydown.enter)="onSubmit()"
    ></mg-input>
  </form>
  <div class="buttons-container">
    <mg-button
      [disabled]="!recoveryForm.value.email"
      [loading]="loading"
      class="w-full"
      (click)="onSubmit()"
      (keypress.space)="onSubmit()"
      (keypress.enter)="onSubmit()"
      >Siguiente</mg-button
    >
    <span class="login-text"
      >¿Ya tienes una cuenta?
      <a routerLink="../login" class="link-login-text">Inicia sesión</a>
    </span>
  </div>
</div>
